import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { mockupSelector } from '../../../../../redux/mockup-manager/mockup-manages.selectors';
import { skipBeforeApprovingMockup } from '../../../../../redux/mockup-manager/mockup-manager.actions';
import BeforeApprovingMockup from './before-approving-mockup';
const mapStateToProps = createSelector(mockupSelector, mockup => {
  return {
    isMockupAvailable: Boolean(mockup)
  };
});
const mapDispatchToProps = dispatch => ({
  onSkip: () => {
    dispatch(skipBeforeApprovingMockup());
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(BeforeApprovingMockup);